import React, { useCallback } from 'react'
import PropTypes from 'prop-types'

import Button from '../../Button/Button'

import './RemoveItemButton.css'
import { useDeleteItemFromCart } from '../../CartMutation/CartMutation'
import { useHandleDelete } from '../use-modifier-form-helpers'

export const RemoveItemButton = ({
  handleDeleteParams,
  values,
  updateError,
  updateLoading,
  loading
}) => {
  const [deleteItemFromCart, { error: deleteError }] = useDeleteItemFromCart()

  const handleDelete = useHandleDelete({
    ...handleDeleteParams,
    deleteItemFromCart
  })

  if (deleteError) {
    updateError(deleteError)
  }

  const handleClick = useCallback(async () => {
    updateLoading(true)
    try {
      await handleDelete(values)
    } catch (error) {
      updateError(error)
    } finally {
      updateLoading(false)
    }
  }, [updateLoading, handleDelete, values, updateError])

  return (
    <div styleName='delete'>
      <Button data-testid='modifier-remove-item-button' onClick={handleClick} disabled={loading}>
        Remove Item
      </Button>
    </div>
  )
}

const handleDeleteParamsShape = PropTypes.shape({
  cartGuid: PropTypes.string.isRequired,
  itemGuid: PropTypes.string.isRequired,
  selectionGuid: PropTypes.string.isRequired,
  getComputedPrice: PropTypes.func.isRequired,
  basePrice: PropTypes.number.isRequired,
  itemDetails: PropTypes.object.isRequired
})

RemoveItemButton.propTypes = {
  handleDeleteParams: handleDeleteParamsShape.isRequired,
  updateError: PropTypes.func.isRequired,
  updateLoading: PropTypes.func.isRequired,
  values: PropTypes.object,
  loading: PropTypes.bool
}
